import * as Redux from 'redux'
import * as App from '../../app'
import * as Actions from './actions'
import * as Types from './types'
import * as Utils from './utils'

export const filterReducer = (sourceReducer: Redux.Reducer<any>, requestEvent: string, initialState: {}) =>
  (state: {}, action: Redux.Action & Actions.FilterActionObject) => {
  const sourceState = sourceReducer(state, action)
  switch (action.type) {
    case App.CONTENT_INIT:
      return initialState
    case Utils.filterStatusConstant(requestEvent):
      return {
        ...sourceState,
        filter: action.filter,
      }
    default:
      return sourceState || initialState
  }
}

export type IsActiveState<T extends Types.IsActive> = T[]

export const dataReducer = (requestEvent: string) =>
  <T extends Types.IsActive>(state: IsActiveState<T>, action: Actions.StateChangeActionObject): IsActiveState<T> => {
    switch (action.type) {
      case Utils.updateStatusConstant(requestEvent):
        const copy = [
          ...state,
        ]
        const matched = copy.filter((lp: any) => lp.id === action.change.id)
        matched.forEach((lp: any) => lp[action.change.key] = action.change.new_value)
        return copy
      default:
        return state
    }
  }

export const chainedReducer = (
  sourceReducer: Redux.Reducer<any>, requestEvent: string) =>
  (state: any, action: Actions.StateChangeActionObject) => {
  const sourceState = sourceReducer(state, action)
  return dataReducer(requestEvent)(sourceState, action)
}



// WEBPACK FOOTER //
// ./src/components/is_active/reducer.ts